import React, { useEffect, useRef, useState } from 'react';
import './manage-quests-landing.styles.scss';
import { properCase } from '@/utils/properCase';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import { getQueryFromFirestore } from '@/utils/getDataFromDbSimplified';
import QuestsList from './quests-list.component';
import QuestForm from './quest-form.component';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import { useEffectiveMembership } from '@/utils/useEffectiveMembership';
import { completeGameElementData } from '@/components/PREVIEW/previewGameElements';

const ManageQuestsLanding = ({
  gameData,
  gameStats,
  gameElements,
  playerList,
  role
}) => {

  const membership = useEffectiveMembership();
  const [showUpgradeModal, setShowUpgradeModal] = useState(null);
  const [questsFromDb, setQuestsFromDb] = useState(null);
  const navigate = useNavigate();
  const questsListenerRef = useRef();
  const questsRef = useRef();
  const location = useLocation();

  const gameId = gameData?.gameId;
  const isPreview = location.pathname.includes('/preview/manager/');

  useEffect(() => {
    if (!gameData?.gameName) return;
    changeDocumentTitle(`Quests | Manage ${gameData?.gameName ?? 'Game'}`);
  }, [gameData?.gameName])

  useEffect(() => {
    if (!membership || !gameData) return;
    checkMembership();
    function checkMembership() {
    const element = 'quests'
    const res = testMemberRestrictions({ 'gameData': gameData, 'membership': membership, 'element': element })
    // console.log(res);
    if (res.disabled) {
      if (!membershipRestrictions) return;
      let message = ''
      const planRest = membershipRestrictions[membership.membership];
      if (res.disabledReason.includes(element)) {
        message = `While using the ${planRest.title}, you are not able to access ${properCase(element)}.`;
      }
      setShowUpgradeModal(message)
    }
  }
  }, [membership, gameData])

  useEffect(() => {
    if (!gameId) return;

    function getGameElementsToManage() {
      if (isPreview) {
        if (!completeGameElementData) return;
        const questObj = {};
        Object.values(completeGameElementData)
          .filter(e => e.type === 'quest' && e.status === 'active')
          .forEach(e => {
            questObj[e.id] = e;
          });
        setQuestsFromDb(questObj);
        return;
      }
      getQueryFromFirestore({
        "path": `games/${gameId}/gameElements`,
        "queryArray": [{
          "field": "type",
          "operator": "==",
          "value": "quest"
        }],
        "callback": callback,
        "handleListener": handleListener
      })
      function callback(data) {
        questsRef.current = {
          ...questsRef.current,
          ...{ [data.id]: data }
        }
        setQuestsFromDb(questsRef.current);
      }
      function handleListener(data) {
        questsListenerRef.current = data;
      }
    }
    getGameElementsToManage();
    return () => {
      if (questsListenerRef.current) {
        questsListenerRef.current();
        questsListenerRef.current = null;
      }
    }
  }, [gameId, isPreview, completeGameElementData])

  return (
    <div className='manage-quests-landing'>
      <Routes>
        <Route path='' element={
          <div className='g-card quests-card'>
            <BackButton cancel={() => navigate(-1)} />
            <div className="g-space-1"></div>
            <div className='card-title'>
              <ImageContainer src='/images/icons/quests.png' className='head-icon' />
              Create and Edit Quests</div>
            <hr />
            <div className='quests-landing-content'></div>
            <QuestsList
              gameData={gameData}
              gameElements={gameElements}
              questsFromDb={questsFromDb}
              role={role} />

          </div>
        }></Route>
        <Route path='create' element={
          <QuestForm
            gameData={gameData}
            gameStats={gameStats}
            gameElements={gameElements}
            playerList={playerList}
            questsFromDb={questsFromDb}
            role={role} />
        }></Route>
        <Route path='edit/:elementPath' element={
          <QuestForm
            gameData={gameData}
            gameStats={gameStats}
            gameElements={gameElements}
            playerList={playerList}
            questsFromDb={questsFromDb}
            role={role} />
        }></Route>
        <Route path="*" element={<Navigate replace to="/404" />} />
      </Routes>
      <UpgradeRequiredModal
        show={showUpgradeModal}
        cancel={() => setShowUpgradeModal(null)}
        message={showUpgradeModal}
      />
    </div>
  )
}

export default ManageQuestsLanding